module.exports = __webpack_public_path__ + "static/media/cogs.812583ef.svg";